// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoDescription_container__mJEO5","video-duration":"VideoDescription_video-duration__2x1uR","video-tags":"VideoDescription_video-tags__1Q7HH"};